var THREE         = require("three");
var GlobalRotationHandleView  = require("./../abstract/globalRotationHandleView.js");
var lib_core      = require("lib-core");
 
var GlobalXRotationView = function (model, editorView, handleId, config) {
    GlobalRotationHandleView.call(this, model, editorView, handleId, config);
}

lib_core.inherit(GlobalXRotationView, GlobalRotationHandleView);

GlobalXRotationView.prototype.repositionMesh = function(mesh, position){
    var matrix = (new THREE.Matrix4()).setPosition( position.toThreejs() );
    mesh.matrix = matrix;
}


GlobalXRotationView.prototype.buildMesh = function(){
    var obj = new THREE.Object3D();
    obj.matrixAutoUpdate = false;
    var geom = this.buildSegGeometry(3).rotateY(Math.PI/2).rotateX(Math.PI/2);
    var mesh = new THREE.Mesh(geom, this.material);
    obj.add(mesh);
    return obj
}

GlobalXRotationView.prototype.hoverChanged = function(value){
    if(value){
        this.handleMesh.children[0].geometry = this.buildRingGeometry(3).rotateY(Math.PI/2).rotateX(Math.PI/2);
        this.handleMesh.children[0].material.transparent = false;
    } else {
        this.handleMesh.children[0].geometry = this.buildSegGeometry(3).rotateY(Math.PI/2).rotateX(Math.PI/2);
        this.handleMesh.children[0].material.transparent = true;
    }
} 


module.exports = GlobalXRotationView;

